import { gettext } from "web/script/modules/django-i18n";
import { languageIsEnglish, languageIs, languageIsIn } from "web/script/modules/language";
/**
 * Utility function to install new global methods into the Jinja-to-JS runtime.
 *
 * @params {Object} jinjaToJs
 */
export function installJinjaGlobals(jinjaToJs) {
    jinjaToJs.globals._ = gettext;
    // placeholder to avoid breaking rothko with SSR react
    jinjaToJs.globals.include_jsx = () => {};
    jinjaToJs.globals.language_is_english = languageIsEnglish;
    jinjaToJs.globals.language_is = languageIs;
    jinjaToJs.globals.language_is_in = languageIsIn;
}
